import styled, {css} from 'styled-components';

import {getColor, gts} from '../../styles';
import {View} from '../View';
import {type Badge} from './index';

export const Container = styled(View)<{variant: Badge.Variant}>`
  display: inline-flex;
  padding-inline: ${gts('padding.sm')};
  padding-block: ${gts('padding.xs')};
  gap: ${gts('gap.xs')};
  border-radius: ${gts('borderRadius.sm')};
  justify-content: center;

  ${p =>
    p.variant === 'primary'
      ? css`
          background-color: ${getColor('background.primary')};
        `
      : undefined}
`;
